// ==========================================================================
// Compensates the scrollbar width when opening modals
// ==========================================================================

class ScrollbarCompensate {
  constructor() {
    this.itemsToFix = [];
    this.scrollbarWidth = 0;
    this.measureDummy = document.createElement('div');
    Object.assign(this.measureDummy.style, {
      width: '50px',
      height: '50px',
      position: 'absolute',
      bottom: '0',
      right: '0',
      'overflow-y': 'scroll',
      'z-index': '-1',
      visibility: 'hidden',
    });

    this.itemsToFix.push(document.querySelector('body'));
    this.itemsToFix.push(...document.querySelectorAll('.hdr-searchbar'));

    this.calculateScrollWidth();
  }

  calculateScrollWidth() {
    document.documentElement.appendChild(this.measureDummy);
    this.scrollbarWidth =
      this.measureDummy.offsetWidth - this.measureDummy.clientWidth;
    document.documentElement.removeChild(this.measureDummy);
  }

  iterateElements(width) {
    if (width !== null) {
      width += 'px';
    }
    this.itemsToFix.map(element => {
      element.style.marginRight = width;
    });
  }

  compensate() {
    if (this.scrollbarWidth !== 0) {
      this.iterateElements(this.scrollbarWidth);
    }
  }

  reset() {
    this.iterateElements(null);
  }
}

export const scrollbarCompensate = new ScrollbarCompensate();



// WEBPACK FOOTER //
// ./src/js/scrollbar-compensate.js